import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "global-loader-overlay"
}
const _hoisted_2 = { class: "loader-container" }
const _hoisted_3 = { class: "loader-progress-container" }
const _hoisted_4 = { class: "loader-progress-track" }
const _hoisted_5 = { class: "progress-text" }
const _hoisted_6 = { class: "loader-text-container" }
const _hoisted_7 = { class: "loader-text" }
const _hoisted_8 = { class: "particles" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "loader-fade" }, {
    default: _withCtx(() => [
      (_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "loader-backdrop" }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "loader-spinner-wrapper" }, [
                _createElementVNode("div", { class: "spinner-ring outer-ring" }),
                _createElementVNode("div", { class: "spinner-ring middle-ring" }),
                _createElementVNode("div", { class: "spinner-ring inner-ring" }),
                _createElementVNode("div", { class: "spinner-center" }, [
                  _createElementVNode("svg", {
                    class: "center-icon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M12 2L2 7L12 12L22 7L12 2Z",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M2 17L12 22L22 17",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }),
                    _createElementVNode("path", {
                      d: "M2 12L12 17L22 12",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "loader-progress-bar",
                    style: _normalizeStyle({ width: _ctx.progress + '%' })
                  }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("div", { class: "progress-glow" }, null, -1)
                  ]))], 4)
                ]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(Math.round(_ctx.progress)) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.loadingText), 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "loader-dots" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "dot" })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "particle",
                    style: _normalizeStyle(_ctx.getParticleStyle(i))
                  }, null, 4)
                }), 64))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}